import * as categories from './list'

export const allProductCategories = Object.values(categories).sort(
    (previous, current) => previous.priority - current.priority,
)
